import React from 'react'

export const LegalText = (): JSX.Element => {
  const termsOfUse = (
    <a href="https://www.influxdata.com/legal/terms-of-use/" target="_blank">
      InfluxDB Cloud 2.0 Services Subscription Agreement
    </a>
  )

  const gdprAgreement = (
    <a
      href="https://www.influxdata.com/legal/influxdata-global-data-processing-agreement/"
      target="_blank"
    >
      InfluxData Global Data Processing Agreement
    </a>
  )

  return (
    <p>
      I have viewed and agree to the {termsOfUse} and {gdprAgreement}.
    </p>
  )
}
